/**
 * Shared barcode-scan copy (POS toast + scanner modal).
 * Keep wording identical so staff see one message for the same situation.
 */

export const barcodeScanSharedFr = {
  unknown: 'Code-barres inconnu',
  notFound: 'Aucun produit pour le code: {{code}}',
  notFoundType: 'Code-barres {{type}} non trouvé',
  outOfStockTitle: 'Produit hors stock',
  outOfStock:
    '{{name}} existe (code {{code}}) mais stock 0 — faites un achat/réception d’abord',
  noCatalog: 'Aucun produit en stock ni au catalogue — rechargez ou créez un produit',
  noInStockList: 'Aucun produit en stock — vérifiez les achats / lots',
  ambiguous: 'Code-barres ambigu',
  ambiguousDetail:
    'Plusieurs produits partagent le code {{code}} — corrigez les doublons ou choisissez via le scanner',
  ambiguousPick: 'Code partagé par plusieurs produits — choisissez',
  skuNotFound: 'SKU ou code personnalisé non trouvé',
  codeTooShort: 'Code trop court',
  codeTooLong: 'Code trop long',
  codeCleanFailed: 'Erreur lors du nettoyage du code',
  productNotFound: 'Produit non trouvé',
  productAdded: 'Produit ajouté',
  productExpired: 'Lot expiré — vente impossible',
  networkError: 'Erreur réseau',
  permissionDenied: 'Permission refusée',
  processingError: 'Erreur lors du traitement'
};

export const barcodeScanSharedAr = {
  unknown: 'الباركود غير معروف',
  notFound: 'لم يتم العثور على منتج للرمز: {{code}}',
  notFoundType: 'الرمز الشريطي {{type}} غير موجود',
  outOfStockTitle: 'المنتج بدون مخزون',
  outOfStock:
    '{{name}} موجود (الرمز {{code}}) لكن الكمية 0 — سجّل شراء/استلام أولاً',
  noCatalog: 'لا منتجات في المخزون ولا في الكتالوج — أعد التحميل أو أنشئ منتجاً',
  noInStockList: 'لا منتجات في المخزون — تحقق من المشتريات / الدفعات',
  ambiguous: 'باركود غامض',
  ambiguousDetail:
    'عدة منتجات تشترك في الرمز {{code}} — أصلح التكرار أو اختر عبر الماسح',
  ambiguousPick: 'رمز مشترك بين عدة منتجات — اختر واحداً',
  skuNotFound: 'SKU أو رمز مخصص غير موجود',
  codeTooShort: 'الرمز قصير جداً',
  codeTooLong: 'الرمز طويل جداً',
  codeCleanFailed: 'خطأ في تنظيف الرمز',
  productNotFound: 'المنتج غير موجود',
  productAdded: 'تمت إضافة المنتج',
  productExpired: 'الدفعة منتهية الصلاحية — لا يمكن البيع',
  networkError: 'خطأ في الشبكة',
  permissionDenied: 'تم رفض الإذن',
  processingError: 'خطأ في المعالجة'
};
